import { render, staticRenderFns } from "./BetaVersionFab.vue?vue&type=template&id=31b40e64&scoped=true&"
import script from "./BetaVersionFab.vue?vue&type=script&lang=js&"
export * from "./BetaVersionFab.vue?vue&type=script&lang=js&"
import style0 from "./BetaVersionFab.vue?vue&type=style&index=0&id=31b40e64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b40e64",
  null
  
)

export default component.exports